/**
 * Redux actions for content
 * @module services/content/redux/actions
 */

export const DELETE_CONTENT = 'DELETE_CONTENT'
export const BULK_DELETE_CONTENT = 'BULK_DELETE_CONTENT'
export const FETCHING_TRANSLATION = 'FETCHING_TRANSLATION'

export const deleteContent = ({ storeKey, contentId }) => {
  if (!contentId) {
    throw new Error('The contentId parameter is required')
  }

  return {
    type: DELETE_CONTENT,
    payload: { storeKey, contentId },
  }
}

export const deleteContentBulk = ({ storeKey, contentIds }) => {
  if (!contentIds || !contentIds.length) {
    throw new Error('The contentIds parameter is required')
  }

  return {
    type: BULK_DELETE_CONTENT,
    payload: { storeKey, contentIds },
  }
}

export const fetchTranslation = ({ storeKey, content }) => {
  if (!content) {
    throw new Error('The content parameter is required')
  }

  return {
    type: FETCHING_TRANSLATION,
    payload: { storeKey, content },
  }
}
